<template>
    <form @submit.prevent="processPayment" id="payment-form" class="p-4 lg:p-12" ref="form" method="post">
        <input type="hidden" name="_token" :value="csrf">
        <input type="hidden" name="paymentIntentId" v-model="paymentIntentId">
        <!-- <input type="text" id="email" placeholder="Enter email address" /> -->
        <div id="payment-element">
            <!-- Injected here -->
        </div>
        <button
            :disabled="payBtnDisabled"
            id="submit"
            class="block transition ease-in-out duration-150 disabled:cursor-not-allowed bg-ap-fs-primary py-2 lg:px-5 lg:py-3 mt-5 text-white rounded-lg w-full bg-ap-fs-primary text-white disabled:text-slate-50 disabled:bg-slate-500"
        >
            <svg v-if="payBtnDisabled" class="inline-block animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Pay Now
        </button>

        <div v-if="error" class="rounded-md bg-red-50 p-4 mt-8">
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3">
                    <p class="text-sm font-medium text-red-800">{{ error }}</p>
                </div>
            </div>
        </div>

        <img src="/images/stripe-badge-white.png" alt="Stripe Secure Badge" class="mt-8 md:w-1/2 inline-block">
        <img src="/images/proud-to-be-green.png" alt="Proud to be green" class="inline-block ml-8">
        <div id="payment-message" class="hidden"></div>
    </form>

</template>

<script>
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';

export default {
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            paymentIntentId: null,
            stripe: {},
            elements: {},
            cardElement: {},
            clientSecret: null,
            error: null,
            payBtnDisabled: false,
        };
    },
    methods: {
        async paymentSetup() {
            await axios.post('/account/booking/pay/setup').then((response) => {
                this.clientSecret = response.data.client_secret;
            }).catch((err) => {
                // TODO: Handle error retrieving secret
                console.log(err);
            });
        },
        processPayment() {
            this.payBtnDisabled = true;

            setTimeout(() => {
                this.payBtnDisabled = false;
            }, 4000);

            this.payWithCard();
        },
        async payWithCard() {
            const { elements } = this;
            const { error } = await this.stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: `https://${window.location.hostname}/account/booking/payment/result`,
                },
            });

            if (error) {
                this.error = error.message;
            }
        },
    },
    watch: {
        paymentIntentId() {
            this.$nextTick(() => {
                this.$refs.form.submit();
            });
        },
    },
    async created() {
        this.stripe = await loadStripe(this.$dataLayer.stripe_key);

        await this.paymentSetup();

        const appearance = {
            theme: 'flat',

            variables: {
                colorPrimary: '#1F2E98',
                colorBackground: '#F5F5F5',
                colorText: '#30313d',
                fontFamily: 'Rubik, ui-sans-serif, system-ui',
            },
        };

        const { clientSecret } = this;
        this.elements = this.stripe.elements({
            clientSecret,
            appearance,
            fonts: [{
                family: 'Rubik',
                cssSrc: 'https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
            }],
        });

        const paymentElement = this.elements.create('payment');
        paymentElement.mount('#payment-element');
    },
};
</script>
